import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { BetModel } from 'features/home/homeSlice';
import { OddModel, defaultOdd } from 'models';
import { PointLevelResponse, PointTeamResponse, TeaserPointResponse } from 'models/teaser';

export interface TeaserState {
  teamPoints: PointTeamResponse[] | null;
  levelPoints: PointLevelResponse[] | null;
  teaserPoints: TeaserPointResponse[] | null;
  teasers: BetModel[];
  currentLevel: number;
}

const initialState: TeaserState = {
  teamPoints: null,
  levelPoints: null,
  teaserPoints: null,
  teasers: [],
  currentLevel: 0,
};

const teaserSlice = createSlice({
  name: 'teaser',
  initialState,
  reducers: {
    setTeamPoints: (state, action: PayloadAction<PointTeamResponse[]>) => {
      state.teamPoints = action.payload;
    },
    setLevelPoints: (state, action: PayloadAction<PointLevelResponse[]>) => {
      state.levelPoints = action.payload;
    },
    setCurrentLevelPoints: (state, action: PayloadAction<number>) => {
      state.currentLevel = action.payload;
    },
    setTeaserPoints: (state, action: PayloadAction<TeaserPointResponse[]>) => {
      state.teaserPoints = action.payload;
    },
    addTeasers: (state, action: PayloadAction<BetModel>) => {
      state.teasers.push(action.payload);
    },
    removeTeaser: (state, action: PayloadAction<string>) => {
      state.teasers = state.teasers.filter((bet) => bet.odd.id !== action.payload);
    },
    removeAllTeasers: (state) => {
      state.teasers = [];
    },
    changeTeaserOdds: (state, action: PayloadAction<OddModel[]>) => {
      state.teasers = state.teasers
        .filter((bet) => action.payload.some((odd) => odd.id === bet.odd.id))
        .map((bet) => ({
          ...bet,
          odd: action.payload.find((o) => o.id === bet.odd.id) || defaultOdd,
        }));
    },
  },
});

export const {
  setTeamPoints,
  setLevelPoints,
  setTeaserPoints,
  addTeasers,
  removeTeaser,
  removeAllTeasers,
  changeTeaserOdds,
  setCurrentLevelPoints,
} = teaserSlice.actions;

export const selectTeamPoints = (state: RootState) => state.teaser.teamPoints;
export const selectLevelPoints = (state: RootState) => state.teaser.levelPoints;
export const selectTeaserPoints = (state: RootState) => state.teaser.teaserPoints;
export const selectTeasers = (state: RootState) => state.teaser.teasers;
export const selecteCurrentLevel = (state: RootState) => state.teaser.currentLevel;
// NOTE: Reducer
export default teaserSlice.reducer;
